<template>
  <div class="d-flex flex-column justify-start align-center">
    <!-- Tarif de base, possiblement majoré -->

    <div class="text-h6 mt-3 text-center" v-if="course_solo">
      <b>{{ tarifs.get_default_tarif_on_home(all_courses) }}€</b> <span
        style="font-size: 9px; position: relative; top: -1px">
        <span v-if="mainStore.module.metadatas?.exclure_taxe != '1'">(+ frais gestion)</span></span>
    </div>
    <div class="text-h6 mt-3 text-center" v-else>
      <b>{{ tarifs.get_default_tarif_on_home(all_courses) }}€/pers</b><br />
      <span style="font-size: 12px">Total {{ total_tarif_equipe }}€</span>
      <span style="font-size: 9px; position: relative; top: -1px"><br />
        <span v-if="mainStore.module.metadatas?.exclure_taxe != '1'">(+ frais gestion)</span></span>
    </div>

    <!-- Modal du détail des tarifs, si il y a des majorations ou plusieurs tarifs -->
    <v-dialog v-if="tarifs.has_upcoming_majorations() || tarifs.list.length > 1" v-model="showDialog" width="500"
      max-width="100%" scroll-strategy="none">
      <template v-slot:activator="{ props }">
        <v-btn color="darkblue" variant="plain" size="small" v-bind="props"><v-icon icon="mdi-information-outline"
            class="mr-1" size="large"></v-icon> Détails tarif </v-btn>
      </template>

      <v-card>
        <v-card-text>
          <TarifItem class="tarif_course_item mb-2 bg-grey_1 px-2 py-1 rounded bordered" v-for="tarif in tarifs.list"
            :key="tarif.id" :tarif="tarif"></TarifItem>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="showDialog = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import TarifItem from "@/components/Home/Courses/Tarif_Item.vue";
export default {
  props: ["tarifs", "course", "all_courses"],
  components: { TarifItem },
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    course_solo() {
      return this.course.is_solo();
    },
    total_tarif_equipe() {
      let equipe_size = this.course.get_equipe_size();
      let total = this.tarifs.get_default_tarif_on_home(this.all_courses) * equipe_size;
      return total;
    },
  },
};
</script>

<style lang="scss" scoped></style>